import { render, staticRenderFns } from "./SaveAsTemplateForm.vue?vue&type=template&id=6016b4f9&scoped=true"
import script from "./SaveAsTemplateForm.vue?vue&type=script&lang=js"
export * from "./SaveAsTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./SaveAsTemplateForm.vue?vue&type=style&index=0&id=6016b4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6016b4f9",
  null
  
)

export default component.exports